/**
 * Constants for Dual Mode Search functionality
 * Centralized location for all hardcoded values to improve maintainability
 */
// Height constants
export const DEFAULT_INPUT_HEIGHT = 120;
export const DEFAULT_PADDING_BOTTOM = 50;
// AI Search Toggle Button
export const AI_SEARCH_TOGGLE_COLLAPSED_HEIGHT = 56;
export const DEFAULT_MIN_EXPANDED_HEIGHT = 800;
// Dimension constants
export const DEFAULT_DRAWER_WIDTH = 400;
export const DEFAULT_CAROUSEL_CARD_WIDTH = '200px';
// Threshold constants (in pixels)
export const SEE_MORE_THRESHOLD = 10;
/** Extra buffer for See More/See Less button layout (border, padding, focus ring) */
export const SEE_MORE_LAYOUT_BUFFER = 8;
export const POLLING_HEIGHT_THRESHOLD = 3;
export const STREAMING_HEIGHT_THRESHOLD = 5;
// Timing constants (in milliseconds)
export const CALCULATION_CACHE_MS = 50;
export const RESIZE_DEBOUNCE_MS = 70;
export const OBSERVER_SETUP_DELAY_MS = 100;
export const RESIZE_CHECK_MS = 150;
export const MUTATION_CHECK_MS = 200;
export const POST_MESSAGE_COOLDOWN_MS = 300;
export const STREAMING_TIMEOUT_MS = 30;
export const TOGGLE_COLLAPSE_DELAY_MS = 100;
// Layout constants
export const DEFAULT_MAX_PAGE_WIDTH = 1200;
//# sourceMappingURL=dualModeConstants.js.map